module.exports = __webpack_public_path__ + "static/img/octavia-timecards.02a1dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/octavia-timecards.jpg
// module id = 343
// module chunks = 0